/* eslint-disable security/detect-object-injection */
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MultiSelectChip } from '../filter-container/filter-container.component';

@Component({
  selector: 'app-multiselect-filter',
  templateUrl: './multiselect-filter.component.html',
  styleUrls: ['./multiselect-filter.component.scss'],
})
/**
 * Multi Select Filter Component
 */
export class MultiSelectFilterComponent {
  @Output() selectFilterClick = new EventEmitter<any>();

  @Input() chips: MultiSelectChip[] = [];
  @Input() filterArray!: any;
  @Input() filterName!: string;

  /**
   * Constructor
   */
  constructor(private readonly dialog: MatDialog) {}

  /**
   * Selects or unselects chip and update filter object
   * @param { MultiSelectChip } chip
   * @param {any} event
   */
  onChipSelectionChange(chip: MultiSelectChip, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    chip.isActive = !chip.isActive;

    const index = this.filterArray?.indexOf(chip.id);
    index === -1
      ? this.filterArray?.push(chip.id)
      : this.filterArray?.splice(index!, 1);

    this.selectFilterClick.emit(this.filterArray);
  }

  /**
   *
   * @return {Array<MultiSelectChip>}
   */
  getSelectedChips(): Array<MultiSelectChip> {
    return this.chips.filter((chip) => chip.isActive);
  }
}
